/**
 * Null-like cell-value recognition, shared by type inference and the client's
 * local PII value scan.
 *
 * PRODUCT.md: blank-like values mean unknown and never overwrite known values.
 * "Empty values" covers the empty string and whitespace-only cells. Common
 * banking-export sentinels (`N/A`, `NA`, `none`, `-`) are treated the same way.
 */

/** The literal null-like token set, normalized to trimmed-lowercase. */
const NULL_LIKE_TOKENS: ReadonlySet<string> = new Set([
  '',
  'null',
  'empty',
  'n-a',
  'n/a',
  'na',
  'none',
  '-',
]);

/** True when a raw cell value is null-like per spec "Type Inference". */
export function isNullLike(raw: string): boolean {
  return NULL_LIKE_TOKENS.has(raw.trim().toLowerCase());
}
